import { NAV_LINKS } from "./data";
import { EnquireButton } from "./EnquireButton";
import logo from "@/assets/logo_full.png";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-line/50 bg-surface/30">
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
      <div className="flex justify-center mb-16">
        <img
          src={logo}
          alt="The Old Pub Cellar, Sauna & Gym — Luxury Unique Retreat"
          className="h-40 md:h-48 w-auto rounded-xl bg-[#F5EFE6] p-4 shadow-[0_20px_60px_-20px_rgba(0,0,0,0.6)]"
          data-testid="footer-logo"
        />
      </div>
      <div className="grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <span className="font-serif text-3xl text-textMain">The Old Pub</span>
          <p className="font-mono text-[10px] uppercase tracking-ultra text-primary/80 mt-2">
            Cellar · Gym · Sauna
          </p>
          <p className="font-sans text-textMuted leading-relaxed mt-6 max-w-sm">
            A luxurious private cellar retreat in the historic Wiltshire Yeoman, Chirton — created by a host obsessed with the little details.
          </p>
        </div>
        <div className="md:col-span-4">
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-textMuted mb-6">Explore</p>
          <ul className="flex flex-col gap-3">
            {NAV_LINKS.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  data-testid={`footer-nav-${l.href.slice(1)}`}
                  className="font-serif text-xl text-textMain/85 hover:text-primary transition-colors"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-3 flex flex-col items-start gap-4">
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-textMuted">A private retreat for two</p>
          <p className="font-sans text-textMuted leading-relaxed text-sm">
            We welcome up to two guests at a time — your stay, and every space within it, is exclusively yours.
          </p>
          <EnquireButton testId="enquire-footer-btn" label="Enquire" className="mt-2" />
        </div>
      </div>
      <div className="mt-16 pt-8 border-t border-line/50 flex flex-col md:flex-row justify-between gap-4">
        <p className="font-mono text-[10px] uppercase tracking-[0.15em] text-textMuted/70">
          © {new Date().getFullYear()} The Old Pub, Chirton · Wiltshire
        </p>
        <p className="font-mono text-[10px] uppercase tracking-[0.15em] text-textMuted/70">
          9.8 Guest Rating · Self Check-in
        </p>
      </div>
    </div>
  </footer>
);
